import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <span className="text-background-50 font-bold text-sm">51</span>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">51动漫</span>
              </div>
              <p className="text-secondary-300 text-sm leading-relaxed">
                51动漫网 - 您的免费动漫天堂。提供海量韩漫、日漫、国漫免费全集，支持追更下拉式阅读，让您畅享无限动漫乐趣。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h6 className="text-background-50 font-semibold mb-4 text-sm">快速导航</h6>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/korean" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">韩漫</Link></li>
                <li><Link to="/category/japanese" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">日漫</Link></li>
                <li><Link to="/category/chinese" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">国漫</Link></li>
              </ul>
            </div>

            {/* About */}
            <div>
              <h6 className="text-background-50 font-semibold mb-4 text-sm">关于我们</h6>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">品牌介绍</Link></li>
                <li><Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">联系方式</Link></li>
                <li><Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">用户口碑</Link></li>
              </ul>
            </div>

            {/* Subscribe */}
            <div>
              <h6 className="text-background-50 font-semibold mb-4 text-sm">关注我们</h6>
              <p className="text-secondary-300 text-sm mb-4 leading-relaxed">
                获取最新动漫更新资讯和推荐
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-secondary-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-secondary-400 text-xs">
              &copy; {new Date().getFullYear()} 51动漫网 版权所有 | 本站内容仅供学习交流，请支持正版
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-secondary-400 hover:text-primary-400 text-xs transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-secondary-400 hover:text-primary-400 text-xs transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-secondary-400 hover:text-primary-400 text-xs transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}